import { faDumpsterFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Sentry from "@sentry/react";
import { Result } from "antd";
import React, { useEffect, useState } from "react";

interface Props {
    children: React.ReactNode;
}

const MapErrorBoundary: React.FC<Props> = (props) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const handleError = (error: Error) => {
            Sentry.captureMessage(error.message);
            setHasError(true);
        };

        const errorHandler = (event: ErrorEvent) => {
            handleError(event.error);
        };

        window.addEventListener("error", errorHandler);

        return () => {
            window.removeEventListener("error", errorHandler);
        };
    }, []);

    if (hasError) {
        return (
            <div className="w-full flex items-center justify-center bg-white">
                <Result
                    title="Error"
                    subTitle="Sorry, map is currently unavailable"
                    icon={<FontAwesomeIcon icon={faDumpsterFire} size="6x" color="#ff9e00" />}
                />
            </div>
        );
    }

    return <>{props.children}</>;
};

export default MapErrorBoundary;
